import { useEffect } from "react";

const ROOF_CALC_SCRIPT_ID = "roof-mammoth-floating-widget";
const ROOF_CALC_SRC = "https://app.roofmammoth.ai/roofcalc-embed.js?key=516d5160-0155-4b46-814b-5f3ab1c12a0f&type=floating&position=bottom-left&text=Get%20An%20Instant%20Estimate&color=%23e8730e&animation=pulse&scale=120";

export function RoofCalcEmbed() {
  useEffect(() => {
    const existingScript = document.getElementById(ROOF_CALC_SCRIPT_ID);
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = ROOF_CALC_SCRIPT_ID;
    script.src = ROOF_CALC_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
